<template>
  <v-container fluid>
    <page-header showBackButton></page-header>

    <v-card class="mb-4">
      <v-card-text>
        <v-form ref="basicForm" @submit.prevent>
          <v-row class="ma-0 mb-4">
            <v-col cols="12" sm="6" lg="3" v-if="id !== null">
              <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('companyNameEn') }}</label>
              <div class="colorBlack--text">{{ selectedCompanyData ? selectedCompanyData.name_en : '-' }}</div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" v-if="id !== null">
              <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('companyNameZh') }}</label>
              <div class="colorBlack--text">{{ selectedCompanyData ? selectedCompanyData.name_zh : '-' }}</div>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" lg="6" v-if="id === null">
              <form-search-select
                label="company"
                :fieldValue.sync="formData.company_id"
                required
                :options="companyOptions"
                @input-search="searchCompany($event)"
                :searching="companySearching"
                searchPlaceholder="companySearchPlaceholder"
                @onselect="handleCompanySelected($event)"
              />
            </v-col>

            <v-col cols="12" sm="6" lg="3">
              <form-date-picker
                label="receivedDate"
                :fieldValue.sync="formData.receive_date"
                required
                manualInput
                disabledActionButtons
              />
            </v-col>
            <v-col cols="12" sm="6" lg="3">
              <form-select label="type" :fieldValue.sync="formData.type" :options="typeOptions" required />
            </v-col>
            <template v-if="id !== null">
              <v-col cols="12" sm="6" lg="3">
                <form-select label="status" :fieldValue.sync="formData.item_status" :options="statusOptions" required />
              </v-col>
              <v-col cols="12" sm="6" lg="3">
                <form-date-picker
                  label="requestLetterActionDate"
                  :fieldValue.sync="formData.request_date"
                  manualInput
                  disabledActionButtons
                  disabled
                />
              </v-col>
              <v-col cols="12" sm="6" lg="3">
                <form-date-picker
                  label="letterActionDate"
                  :fieldValue.sync="formData.action_date"
                  manualInput
                  disabledActionButtons
                />
              </v-col>
              <v-col cols="12" sm="6" lg="3">
                <v-btn
                  x-large
                  elevation="0"
                  color="primary"
                  type="button"
                  @click="recipientDialogOpen = true"
                  :disabled="formData.to_info.name == ''"
                  >{{ $t('viewRecipientInfo') }}</v-btn
                >
              </v-col>
              <v-col cols="12">
                <image-uploader
                  :fileValue.sync="formData.file"
                  label="uploadScanFile"
                  fileType="imgWithPDF"
                  inputRef="uploadScanFile"
                />
              </v-col>
              <v-col cols="12">
                <form-textarea label="transferRemark" :fieldValue.sync="formData.remark" :rows="5" />
              </v-col>
            </template>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-btn
      depressed
      elevation="0"
      class="ml-2 mb-4"
      color="primary"
      type="button"
      @click="save()"
      :loading="$store.getters.isLoading"
      >{{ $t('save') }}</v-btn
    >

    <!-- Modal: 查看收件資料 -->
    <dialog-layout
      :open="recipientDialogOpen"
      title="recipientInfo"
      :maxWidth="900"
      confirmBtnTitle="close"
      @close="recipientDialogOpen = false"
    >
      <template slot="content">
        <v-row class="ma-0">
          <v-col cols="12">
            <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('transferMethod') }}</label>
            <div class="colorBlack--text">
              {{ formData.to_info.method ? $t(`transferMethodOptions.${formData.to_info.method}`) : '-' }}
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('recipientName') }}</label>
            <div class="colorBlack--text">{{ formData.to_info.name }}</div>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('recipientPhone') }}</label>
            <div class="colorBlack--text">{{ formData.to_info.tel }}</div>
          </v-col>
          <v-col cols="12">
            <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('recipientAddress') }}</label>
            <div class="colorBlack--text">{{ formData.to_info.address }}</div>
          </v-col>
        </v-row>
      </template>
    </dialog-layout>
  </v-container>
</template>

<script>
import FormSelect from '@/components/form/FormSelect.vue'
import Datatable from '@/components/Datatable.vue'
import FormDatePicker from '@/components/form/FormDatePicker.vue'
import FormSearchSelect from '@/components/form/FormSearchSelect.vue'
import ImageUploader from '@/components/form/ImageUploader.vue'
import FormTextarea from '@/components/form/FormTextarea.vue'
import DialogLayout from '@/components/layout/DialogLayout.vue'
export default {
  name: 'LetterPackageDetail',
  components: {
    FormSelect,
    Datatable,
    FormDatePicker,
    FormSearchSelect,
    ImageUploader,
    FormTextarea,
    DialogLayout,
  },
  computed: {
    id() {
      const id = parseInt(this.$route.params.id)
      if (!isNaN(id)) {
        return id
      }

      return null
    },
  },
  data: vm => ({
    initData: {
      item_status: '',
    },
    formData: {
      receive_date: '',
      company_id: -1,
      type: '',
      item_status: 'pending',
      file: '',
      remark: '',
      to_info: {
        method: '',
        name: '',
        tel: '',
        address: '',
      },
      request_date: '',
      action_date: '',
    },

    companySearching: false,
    companyOptions: [],
    selectedCompanyData: null,

    recipientDialogOpen: false,

    statusOptions: [
      { value: 'pending', text: vm.$t('letterStatusOptions.pending') },
      { value: 'scanned', text: vm.$t('letterStatusOptions.scanned') },
      { value: 'forwarded', text: vm.$t('letterStatusOptions.forwarded') },
      { value: 'picked_up', text: vm.$t('letterStatusOptions.picked_up') },
      { value: 'request_forward', text: vm.$t('letterStatusOptions.request_forward'), disabled: true },
      { value: 'request_scan', text: vm.$t('letterStatusOptions.request_scan'), disabled: true },
      { value: 'request_pick_up', text: vm.$t('letterStatusOptions.request_pick_up'), disabled: true },
    ],
    typeOptions: [
      { value: 'letter', text: vm.$t('letterTypeOptions.letter') },
      { value: 'package', text: vm.$t('letterTypeOptions.package') },
    ],
  }),
  methods: {
    async getLetter() {
      try {
        const data = await this.$Fetcher.GetLetterById(this.id)
        for (let key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }
        for (let key in this.initData) {
          if (this.$validate.DataValid(data[key])) {
            this.initData[key] = data[key]
          }
        }

        if (data.to_info) {
          if (data.to_info.method) {
            this.formData.to_info.method = data.to_info.method
          }
          if (data.to_info.address) {
            this.formData.to_info.address = data.to_info.address
          }
          if (data.to_info.name) {
            this.formData.to_info.name = data.to_info.name
          }
          if (data.to_info.tel) {
            this.formData.to_info.tel = data.to_info.tel
          }
        }

        await this.getCompany()
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setAlert', {
          message: 'noData',
          redirect: 'LetterPackageList',
        })
      } finally {
        this.$store.dispatch('setInitLoading', false)
      }
    },
    async getCompany() {
      try {
        const data = await this.$Fetcher.GetCompanyById(this.formData.company_id)
        this.selectedCompanyData = data
      } catch (err) {
        this.$common.error(err)
      }
    },

    async searchCompany(keyword = '') {
      if (this.companySearching) {
        return
      }

      this.companySearching = true
      let payload = {}
      if (keyword) {
        payload['search'] = keyword
      }

      try {
        const { data } = await this.$Fetcher.GetCompanies(payload)
        this.companyOptions = data.map(item => {
          return {
            value: item.id,
            text: item.name_zh || item.name_en,
            ...item,
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.companyOptions = []
      } finally {
        this.companySearching = false
      }
    },
    handleCompanySelected(value) {
      this.selectedCompanyData = this.companyOptions.find(el => el.value === value)
    },

    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', {
          message: 'processing',
        })
        return
      }

      const valid = await this.$refs['basicForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', {
          message: 'required',
        })
        return
      }

      this.$store.dispatch('setLoading', true)
      let payload = {
        item_status: this.formData.item_status,
        type: this.formData.type,
        company_id: this.formData.company_id,
        user_id: this.selectedCompanyData.user_id,
        company_en: this.selectedCompanyData.name_en,
        company_zh: this.selectedCompanyData.name_zh,
        receive_date: this.formData.receive_date,

        action_date: this.formData.action_date,
        file: this.formData.file,
        remark: this.formData.remark,
        to_info: {
          method: this.formData.to_info.method,
          name: this.formData.to_info.name,
          tel: this.formData.to_info.tel,
          address: this.formData.to_info.address,
        },
      }

      if (this.$validate.DataValid(this.id)) {
        if (payload.item_status !== this.initData.item_status) {
          payload['item_status_change'] = this.initData.item_status
        }
        try {
          await this.$Fetcher.UpdateLetter(this.id, payload)
          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
            type: 'success',
            message: 'message.saveSuccess',
            refresh: true,
          })
        } catch (err) {
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setAlert', {
            title: 'message.saveFail',
            message: err,
            type: 'error',
          })
        }
      } else {
        try {
          const data = await this.$Fetcher.NewLetter(payload)
          this.$store.dispatch('setDataIsUpdated', false)
          await this.sendAlert(data.id)
        } catch (err) {
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setAlert', {
            title: 'message.saveFail',
            message: err,
            type: 'error',
          })
        }
      }
    },

    async sendAlert(id) {
      try {
        await this.$Fetcher.NewAlert({
          type: 'package',
          data: 'package_data',
          data_id: id,
          company_id: this.formData.company_id,
          user_id: this.selectedCompanyData.user_id,
        })
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('toggleSnack', {
          type: 'success',
          message: 'message.saveSuccess',
          redirect: 'LetterPackageList',
        })
      }
    },
  },

  async mounted() {
    this.$store.dispatch('setInitLoading', true)
    if (this.$validate.DataValid(this.id)) {
      // edit
      this.getLetter()
    } else {
      // new
      this.searchCompany()
      this.$store.dispatch('setInitLoading', false)
    }
  },
}
</script>
